import { useApp } from "../providers";
import React from "react";
import { SrtRadioChannelNameContainer } from "./styles";
import { SrtChannelHighlightSquare } from "./styles";
import { SrtRadioChannelName } from "./styles";

export const ChannelHeader = () => {
  const { darkMode } = useApp();
  return (
    <SrtRadioChannelNameContainer darkMode={darkMode}>
      {/* <SrtChannelHighlightSquare /> */}
      <SrtRadioChannelName>SRC Dispatch</SrtRadioChannelName>
    </SrtRadioChannelNameContainer>
  );
};
